import Vue from 'vue'
import router from './router/router.js'
import App from './App.vue'
import { store } from './store/store'
import VueCookies from 'vue-cookies'
import VueAnalytics from 'vue-analytics'

Vue.use(VueCookies)

const analyticsID = (window.location.host === 'andrew.ooo' || window.location.host.indexOf('localhost') > -1) ? 'UA-107485979-1' : 'UA-115753032-1'
Vue.use(VueAnalytics, {
  id: analyticsID,
  router,
  debug: {
      enabled: false,
      sendHitTask: true
  }
})

new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js